(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["editor-section-ref"] && !Shopify.designMode) return;
  try {
    (function () {
    function bindThemeEditorLinks() {
      document.querySelectorAll('a[data-editor-key]').forEach((link) => {
        const source = document.querySelector('[data-theme-editor-key="' + link.getAttribute('data-editor-key') + '"]');
        if (source && source.getAttribute('data-theme-editor-href')) {
          link.setAttribute('href', source.getAttribute('data-theme-editor-href'));
        }
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindThemeEditorLinks);
    } else {
      bindThemeEditorLinks();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
